import { t } from "../../../services/utils";
import React from "react";
import { primaryDark10, grey200 } from "../../../constants/colors";
class LinkView extends React.Component {
  constructor(props) {
    super(props);
  }
  onClick = () => {
    window.open(this.props.link.url, "_blank");
  };
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        height: "100%",
        padding: 10,
        paddingLeft: 16,
        paddingRight: 16,
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      inner: {
        borderWidth: 1,
        borderColor: primaryDark10,
        borderStyle: "solid",
        borderRadius: 2,
        height: 100,
        cursor: "pointer",
        display: "flex",
      },
      placeholderWrapper: {
        height: 100,
        width: 100,
        display: "flex",
        backgroundColor: primaryDark10,
      },
      placeholderIcon: {
        fontSize: "84px",
        alignSelf: "center",
        margin: "auto",
        color: grey200,
      },
      main: {
        display: "flex",
        overflow: "hidden",
        height: "100%",
        flex: "1 1 auto",
        alignItems: "center",
      },
      title: {
        padding: 10,
        fontSize: 16,
      },
      image: {
        objectFit: "cover",
        width: 100,
        height: 100,
      },
    };
    let imageView;
    if (this.props.link.purl) {
      imageView = (
        <img
          style={styles.image}
          height={100}
          width={100}
          src={this.props.link.purl}
        />
      );
    } else {
      imageView = (
        <div style={styles.placeholderWrapper}>
          <i className={"material-icons"} style={styles.placeholderIcon}>
            insert_photo
          </i>
        </div>
      );
    }
    let title = this.props.link.ti ? this.props.link.ti : this.props.link.url;
    return (
      <div style={styles.container}>
        <div style={styles.inner} onClick={this.onClick}>
          {imageView}
          <div style={styles.main}>
            <div style={styles.title}>{title}</div>
          </div>
        </div>
      </div>
    );
  };
  static getHeight(props) {
    return 120;
  }
}
export default LinkView;
